var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.59188 0.67557C8.75883 0.33731 9.24117 0.33731 9.40811 0.67557L11.8367 5.59641C11.903 5.73073 12.0311 5.82384 12.1794 5.84538L17.6098 6.63447C17.9831 6.68871 18.1322 7.14745 17.8621 7.41075L13.9325 11.2411C13.8253 11.3456 13.7763 11.4963 13.8017 11.6439L14.7293 17.0525C14.7931 17.4242 14.4028 17.7078 14.0689 17.5322L9.21178 14.9787C9.0792 14.909 8.9208 14.909 8.78822 14.9787L3.93106 17.5322C3.59718 17.7078 3.20695 17.4242 3.27071 17.0525L4.19835 11.6439C4.22367 11.4963 4.17472 11.3456 4.06746 11.2411L0.137936 7.41075C-0.132181 7.14745 0.0168728 6.68871 0.390164 6.63447L5.82063 5.84538C5.96887 5.82384 6.09701 5.73073 6.16331 5.59641L8.59188 0.67557Z",
    fill: "#F7D644"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeActive);
export default __webpack_public_path__ + "static/media/like_active.02b9270dc28364bd3659356ee5a4df0f.svg";
export { ForwardRef as ReactComponent };